var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import List from "react-virtualized/dist/es/List";
const RowHeight = 45;
const Width = 500;
const ResultsList = forwardRef(function ResultsList(_a, ref) {
    var { maxItems = 20, itemComponent: ItemComponent, items, query, selectedIndex, setSelectedIndex } = _a, props = __rest(_a, ["maxItems", "itemComponent", "items", "query", "selectedIndex", "setSelectedIndex"]);
    const listRef = useRef(null);
    const startIndex = useRef(0);
    const stopIndex = useRef(0);
    const itemCount = items.length;
    const height = Math.min(itemCount, maxItems) * RowHeight;
    useImperativeHandle(ref, () => ({
        scrollToRow(index) {
            var _a;
            (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToRow(index);
        },
        scrollByPage(direction) {
            const pageIncrement = Math.min(maxItems, items.length) - 1;
            let newIndex = selectedIndex;
            if (direction === "down") {
                if (selectedIndex === stopIndex.current) {
                    newIndex = Math.min(selectedIndex + pageIncrement, items.length - 1);
                }
                else {
                    newIndex = stopIndex.current;
                }
            }
            else if (selectedIndex === startIndex.current) {
                newIndex = Math.max(selectedIndex - pageIncrement, 0);
            }
            else {
                newIndex = startIndex.current;
            }
            setSelectedIndex(newIndex);
        }
    }));
    function rowRenderer({ index, key, style }) {
        const item = items[index];
        return (React.createElement(ItemComponent, { key: key, index: index, item: item, isSelected: selectedIndex === index, style: style }));
    }
    function handleRowsRendered(event) {
        // track the visible rendered rows so we know how to change the
        // selection when the App tells us to page up/down, since the App
        // doesn't know what's visible
        startIndex.current = event.startIndex;
        stopIndex.current = event.stopIndex;
    }
    return (React.createElement(List, Object.assign({ ref: listRef, tabIndex: -1, width: Width, height: height, rowCount: itemCount, rowHeight: RowHeight, rowRenderer: rowRenderer, scrollToIndex: selectedIndex, onRowsRendered: handleRowsRendered }, props)));
});
export default ResultsList;
